import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Controller } from "./controller";
import { getScope as formScope, watchChange, toArray, loaded, markLoaded } from "@ideal-postcodes/jsutil";

var isTrue = function isTrue() {
  return true;
};

var NOOP = function NOOP() {};

var getAnchors = function getAnchors(config) {
  var scope = formScope(config.scope || null);
  var matches = scope.querySelectorAll(config.anchor || config.context || config.scope);
  return toArray(matches).filter(function (e) {
    return !loaded(e);
  });
};
/**
 * Dynamically apply PostcodeLookup
 * when relevant html configuration appear
 * - Exits if page test is fails
 * - Not binding when context is null or already have controller bound
 * - Use controller bind to build solution
 */


export var watch = function watch(config) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$pageTest = options.pageTest,
      pageTest = _options$pageTest === void 0 ? isTrue : _options$pageTest,
      _options$onError = options.onError,
      onError = _options$onError === void 0 ? NOOP : _options$onError,
      _options$onBindAttemp = options.onBindAttempt,
      onBindAttempt = _options$onBindAttemp === void 0 ? NOOP : _options$onBindAttemp,
      _options$onBind = options.onBind,
      onBind = _options$onBind === void 0 ? NOOP : _options$onBind,
      anchor = options.anchor,
      _options$onAnchorFoun = options.onAnchorFound,
      onAnchorFound = _options$onAnchorFoun === void 0 ? NOOP : _options$onAnchorFoun,
      _options$getScope = options.getScope,
      getScope = _options$getScope === void 0 ? formScope : _options$getScope;
  var controller;

  var bind = function bind() {
    try {
      onBindAttempt(config);
      getAnchors(_objectSpread({
        anchor: anchor
      }, config)).forEach(function (anchor) {
        if (!pageTest()) return;
        var scope = getScope(anchor);
        onAnchorFound({
          anchor: anchor,
          scope: scope,
          config: config
        }); //deploy solution

        controller = new Controller(config);
        markLoaded(anchor);
        onBind(controller);
      });
    } catch (error) {
      onError(error);
    }
  }; // @ts-expect-error


  var _watchChange = watchChange({
    config: config,
    bind: bind
  }),
      start = _watchChange.start,
      stop = _watchChange.stop; //start watching changes


  start();
  return {
    start: start,
    stop: stop,
    controller: controller
  };
};